import * as React from 'react'
import { LIGHTER_GRAY } from '@omnilert/components'


/**
 * Renders a circle with a plus/add SVG icon
 * @returns {JSX.Element} Circle plus icon SVG element
 */
function CirlcePlus() {
  return (
    <svg
      fill='none'
      height={18}
      viewBox='0 0 24 24'
      width={18}
    >
      <path
        d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z'
        stroke={LIGHTER_GRAY}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      />
      <path
        d='M12 6v12M18 12H6'
        stroke={LIGHTER_GRAY}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default CirlcePlus
